var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rootStyles,on:{"click":_vm.handleOpen}},[_c('ChatIcon',{attrs:{"width":"22","height":"22"}}),_vm._v(" "),_c('HeaderDirectMessagesPromo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }